import React, { useState, useRef } from "react";
import "./AIAcademyContent.css";
import ExplorebyProgram from './ExplorebyProgram.jsx';
import ExplorebyRoles from './ExplorebyRoles.jsx';
import ExplorebyTopic from './ExplorebyTopic.jsx';
import "../Searchnav.css";

function AIAcademyContent() {

  const tabLabels = ["Explore by Topic", "Explore by Roles", "Explore by Program"];
  const [activeTab, setActiveTab] = useState(tabLabels[0]);
  const [activeIndex, setActiveIndex] = useState(0);
  const tabContainerRef = useRef(null);

  const handleArrowClick = (direction) => {
    let newIndex = activeIndex;
    if (direction === "left" && activeIndex > 0) newIndex--;
    if (direction === "right" && activeIndex < tabLabels.length - 1) newIndex++;
    setActiveTab(tabLabels[newIndex]);
    setActiveIndex(newIndex);
    centerActiveTab(newIndex);
  };

  const centerActiveTab = (index) => {
    const container = tabContainerRef.current;
    const tab = container?.children[index];
    if (container && tab) {
      const containerWidth = container.offsetWidth;
      const tabWidth = tab.offsetWidth;
      const scrollPosition = tab.offsetLeft - containerWidth / 2 + tabWidth / 2;
      container.scrollTo({ left: scrollPosition, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="video-container" id="main">
        <img
          src={process.env.PUBLIC_URL + "/images/AIAcademy/New-Banner.png"}
          alt="AIAcademy-Banner"
          className="banner-img desktop-banner"
        />
        <img
          src={process.env.PUBLIC_URL + "/images/AIAcademy/BannerwithText.png"}
          alt="AIAcademy-Banner"
          className="banner-img mobile-banner"
        />
        <div className="heading-text-box">
          <h1 tabIndex={0}>AI Academy</h1>
          <p>
            Empowering Every Role with AI Skills.
          </p>
        </div>
      </div>

      {/* first section */}
      <div className="agentic-ai-container">
        <div className="agentic-ai-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Overview</h2>
          </div>
          <p className="overview-content">
            AI Academy empowers professionals across all roles to build essential AI skills that enhance
            productivity, innovation, and informed decision-making. Through focused, role based learning,
            it prepares individuals to apply AI effectively and contribute to organizational growth in
            a digital-first world.
          </p>
        </div>
      </div>

      <section className="academies-tracks-section" data-aos="fade-up">
        <div className="academies-tracks-wrap">
          <button
            className="tab-arrow left-arrow"
            onClick={() => handleArrowClick("left")}
            aria-label="Scroll left"
          >
            &#10094;
          </button>
          <div className="tabs-container"  ref={tabContainerRef}>
            {tabLabels.map((label) => (
            <button
              key={label}
              className={`tab-item ${activeTab === label ? "active" : ""}`}
              onClick={() => setActiveTab(label)}
            >
              {label}
            </button>
          ))}
          </div>
          <button
            className="tab-arrow right-arrow"
            onClick={() => handleArrowClick("right")}
            aria-label="Scroll right"
          >
            &#10095;
          </button>
          {/* Tab Content */}
          <div className="track-grid">
            {activeTab === "Explore by Topic" && <ExplorebyTopic />}
            {activeTab === "Explore by Roles" && <ExplorebyRoles />}
            {activeTab === "Explore by Program" && <ExplorebyProgram />}
          </div>
        </div>
      </section>
    </>
  );
}

export default AIAcademyContent;
